import { useState } from 'react';

import {
  Heading,
  VStack,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Box,
  Text,
  LightbulbIcon,
  OutlineCircleQuestionIcon,
  DrawerCloseButton,
} from '@frontend/legacy-components';

import { SupportDrawer } from 'components/support';

import { RELEASE, SERVER } from 'constants/all';

import { capitalize } from 'utils/stringUtils';

import HelpModeResourceCard from './HelpModeResourceCard';
import { LatestProductUpdates } from './latestProductUpdates';

type HelpModeDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const trimSemVerFixVersion = (version: string) => {
  return version.split('.').slice(0, -1).join('.');
};

const HelpModeDrawer = ({ isOpen, onClose }: HelpModeDrawerProps) => {
  const [isSupportDrawerOpen, setIsSupportDrawerOpen] = useState(false);

  const displayableAppVersion = RELEASE
    ? trimSemVerFixVersion(RELEASE)
    : SERVER
    ? `(${capitalize(SERVER)})`
    : null;

  return (
    <Drawer onClose={onClose} isOpen={isOpen} size="lg">
      <DrawerContent>
        <DrawerHeader>
          Help
          <DrawerCloseButton />
        </DrawerHeader>
        <DrawerBody pb={0} pt={0}>
          {isOpen && (
            <Box
              display="flex"
              flexDirection="column"
              width="100%"
              minHeight="100%"
            >
              <VStack spacing={2} width="100%">
                <LatestProductUpdates />
                <Box width="100%" pt={2}>
                  <Heading size="lg" fontWeight="heavy" mb={1.5}>
                    Resources
                  </Heading>
                  <VStack spacing={2} width="100%">
                    <HelpModeResourceCard
                      title="Knowledge Base"
                      icon={<LightbulbIcon />}
                      description="Browse tutorials, articles, videos, and more"
                      as="a"
                      target="_blank"
                      href="https://help.paperlessparts.com"
                    />
                    <HelpModeResourceCard
                      textAlign="left"
                      title="Contact Support"
                      icon={<OutlineCircleQuestionIcon />}
                      description="Ask a question, report a bug, or submit feedback"
                      as="button"
                      onClick={() => {
                        setIsSupportDrawerOpen(!isSupportDrawerOpen);
                      }}
                    />
                  </VStack>
                </Box>
              </VStack>
              {displayableAppVersion && (
                <Text
                  ml="auto"
                  mt="auto"
                  color="feature.secondary"
                  py={2}
                  textAlign="end"
                  size="sm"
                >
                  Paperless Parts {displayableAppVersion}
                </Text>
              )}
            </Box>
          )}
        </DrawerBody>
        <SupportDrawer
          isOpen={isSupportDrawerOpen}
          onClose={() => {
            setIsSupportDrawerOpen(false);
            onClose();
          }}
        />
      </DrawerContent>
    </Drawer>
  );
};

export default HelpModeDrawer;
